import { apiUrl } from './setup'

const uuid = () => window.crypto?.randomUUID?.() || 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
  const r = Math.floor(Math.random() * 16)
  return (c === 'x' ? r : (r & 3) | 8).toString(16)
})
let memoryVisitor
export const trackWebVisit = (pathname, search = '') => {
  let page = pathname.replace(/\/+$/, '') || '/'
  const folder = window.pathFolder || ''
  if (folder && page.startsWith(folder)) page = page.slice(folder.length) || '/'
  if (!['/', '/nosotros', '/contacto', '/productos'].includes(page) && !/^\/evento\/[^/]+(?:\/[^/]+)?$/.test(page)) return
  let visitorId = memoryVisitor || uuid()
  try {
    const stored = localStorage.getItem('rockstar_visit_browser')
    visitorId = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(stored || '') ? stored : visitorId
    localStorage.setItem('rockstar_visit_browser', visitorId)
  } catch (_) { /* Storage can be unavailable; keep a browser-memory identifier. */ }
  memoryVisitor = visitorId
  const params = new URLSearchParams(search)
  let source = params.get('utm_source') || ''
  if (!source && document.referrer) {
    try { const ref = new URL(document.referrer); if (ref.hostname !== window.location.hostname) source = ref.hostname } catch (_) {}
  }
  const width = window.innerWidth
  fetch(apiUrl({ url: '/visits/track' }), {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
    body: JSON.stringify({ navigation_id: uuid(), visitor_id: visitorId, page,
      source: source.slice(0, 120), device: width < 768 ? 'mobile' : width < 1024 ? 'tablet' : 'desktop' }),
  }).catch(() => {})
}
